import { render, staticRenderFns } from "./downline.vue?vue&type=template&id=6087edb6&"
import script from "./downline.vue?vue&type=script&lang=js&"
export * from "./downline.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports